import React, { useCallback, useEffect, useState, useMemo } from "react";
import classNames from "classnames";
import { Classes } from "@blueprintjs/core";
import TextField from "components/Controls/TextField";
import { INPUT } from "shared/labels";
import { InputDirection } from "shared/types";
import { isNotEmpty, isNumberValid } from "utils/validate";
import { renderNumberValue, getNumberFromNumberString, checkMantisLength } from "utils/string";
import * as styles from "./styles.module.scss";
const NumberInput = ({ value, placeholder, disabled, className, readonly = false, onChange, onFocus, onBlur, direction = InputDirection.LEFT, testId, unit, prefix, }) => {
    const [internalValue, setInternalValue] = useState();
    const handleBlur = useCallback((e) => {
        onChange(internalValue?.trim());
        onBlur && onBlur(e);
    }, [internalValue, onBlur, onChange]);
    const onValueChange = useCallback((e) => {
        const value = e.target.value;
        if (!checkMantisLength(value)) {
            return;
        }
        setInternalValue(value);
        if (String(value) === String(internalValue)) {
            return;
        }
        onChange(value === "" ? undefined : value);
    }, [internalValue, onChange]);
    useEffect(() => {
        if (value !== internalValue) {
            if (isNotEmpty(value, true) && isNumberValid(value)) {
                setInternalValue(renderNumberValue(getNumberFromNumberString(value ?? "", false), {
                    roundingDisabled: true,
                }));
            }
            else {
                setInternalValue("");
            }
        }
    }, [value, internalValue]);
    const readOnlyValue = useMemo(() => {
        return isNotEmpty(internalValue, true) ? (React.createElement(React.Fragment, null,
            internalValue,
            unit && React.createElement("span", { dangerouslySetInnerHTML: { __html: unit } }))) : (INPUT.UNDEFINED);
    }, [internalValue, unit]);
    const handleKeyPress = useCallback((event) => {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    }, []);
    return (React.createElement("div", { className: classNames(styles["number-input"], className, { [styles.readonly]: readonly }) }, readonly ? (React.createElement("span", { className: classNames(styles.readonlyText, { [styles["empty"]]: !isNotEmpty(internalValue, true) }) }, readOnlyValue)) : (React.createElement(TextField, { value: internalValue ?? "", placeholder: placeholder, type: "text", classes: {
            container: styles.fieldContainer,
            input: classNames(Classes.INPUT, styles.input, [styles[`direction-${direction}`]]),
        }, hideRemainingSymbols: true, onChange: onValueChange, onBlur: handleBlur, onFocus: onFocus, onKeyPress: handleKeyPress, "data-testid": testId, direction: direction, prefix: prefix, disabled: disabled, ...(unit ? { suffix: unit } : {}) }))));
};
export default NumberInput;
